import React from 'react';
import { Column } from 'components/Layouts/Flow';

import Courses from 'containers/Administrator/Users/Create_Old/Teacher/Courses';

const Teacher = () => {
	return (
		<Column size="12" className="withMarginTop">
			<Courses />
		</Column>
	);
};

export default Teacher;
